export enum $riskMetricsChartData {
  dpCountsByRiskLevel = 'dpCountsByRiskLevel',
  computedAt = 'computedAt',
}

export enum $riskMetricsChartConfig {
  data = 'data',
  frequency = 'frequency',
}
